export const config = {
    // api_base: 'https://promotion.techexposys.com/',
    api_base: 'https://api.adoop.in/',
};
